import { Injectable } from '@angular/core';
import { HttpService } from '../app/utility/http-service';

export interface DataSourceModel {
  DataSourceId: string;
  name: string;
  tablePrefix?: string;
  legacyEncryption: boolean;
  encryptionKey?: string;
  connectionType: 'File' | 'Data';
  data: { [key: string]: string | null };
  editing?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ClientDataSourceService {
  private readonly basePath = 'ClientSettings';

  constructor(private http: HttpService) { }

  getDataSources(
    clientId: string,
    onSuccess: (res: DataSourceModel[]) => void,
    onError?: (err: any) => void
  ): void {
    const uri = `${this.basePath}/GetDataSources?clientId=${clientId}`;

    this.http.get<DataSourceModel[]>(
      uri,
      onSuccess,
      true
    );
  }

  saveDataSource(
    clientId: string,
    dsId: string,
    config: any,
    onSuccess: () => void,
    onError?: () => void
  ): void {

    const url =
      `${this.basePath}/UpdateDataSource` +
      `?clientId=${clientId}` +
      `&recordId=${dsId}` +
      `&useLegacyEncryption=${config.LegacyEncryption}`;

    this.http.postReturn(
      url,
      onSuccess,
      undefined,
      config,
      onError
    );
  }

  deleteDataSource(
    clientId: string,
    dsId: string,
    onSuccess: () => void,
    onError?: () => void
  ): void {
    const uri = `${this.basePath}/DeleteDataSource?clientId=${clientId}&dsId=${dsId}`;
    this.http.deleteReturn(uri, onSuccess, onError);
  }
}
